// import dependencies
import { createPopper, main } from "@popperjs/core";
import {
  constrainRange,
  isSelectionForward,
  getEndLineRect,
  getAllRect,
} from "./selection.js";
import { getOffsetScroll } from "./dom.js";
import { lifeCycleFactory } from "./popover.js";

import { concat } from "../util/string";
import { extend, isCallable } from "../util/utils.js";

let _undefined;
// prettier-ignore
const eventTypes = [ "selectionchange", "mouseup", "touchend", "touchcancel" ];

// return UserList class
export default (opts) => {
  let elem = {};

  const options = (Object.assign || extend)(
    {
      document,
      selector: "body",
      //popoverClass: "share-this-popover",
      // prettier-ignore
      transformer: raw => raw.trim().replace(/\s+/g, " "),
    },
    opts || {}
  );

  let initialized = false;
  let destroyed = false;

  let _document = _undefined;
  let _window = _undefined;

  let selectionFrame = _undefined;
  let mainTooltip = _undefined;
  let lifeCycle = _undefined;
  let popperInstance = null;
  let rangeObj = {};

  //let ul = document.createElement("ul");
  return {
    init() {
      if (initialized) return false;

      _document = options.document;
      _window = _document.defaultView;
      if (!_window.getSelection) {
        // eslint-disable-next-line no-console
        console.warn("share-this: Selection API isn't supported");
        return false;
      }

      eventTypes.forEach(addListener);
      _window.addEventListener("resize", resizeHandler);
      _window.addEventListener("message", receiveMessage, false);

      lifeCycle = lifeCycleFactory(_document);

      return (initialized = true);
    },

    destroy() {
      if (!initialized || destroyed) return false;

      eventTypes.forEach(removeListener);
      _window.removeEventListener("resize", resizeHandler);
      _window.removeEventListener("message", receiveMessage);

      killPopover();

      _document = _undefined;
      _window = _undefined;

      return (destroyed = true);
    },
    reposition() {
      if (selectionFrame) {
        //stylePopover(popover, getConstrainedRange(), options);
        styleSelectionFrame(getConstrainedRange(), options);
      }
      return !!selectionFrame;
    },
  };

  function addListener(type) {
    _document.addEventListener(type, selectionCheck);
  }
  function removeListener(type) {
    _document.removeEventListener(type, selectionCheck);
  }
  function resizeHandler() {
    if (selectionFrame) {
      //stylePopover(popover, getConstrainedRange(), options);
      styleSelectionFrame(getConstrainedRange(), options);
    }
  }

  function selectionCheck({ type }) {
    const shouldHavePopover = type === "selectionchange";
    if (!selectionFrame !== shouldHavePopover) {
      // Safari iOS fires selectionchange *before* click, so tapping on a sharer would be prevented
      setTimeout(() => {
        if (_window) {
          const range = getConstrainedRange();
          if (range) drawPopover(range);
          else killPopover();
        }
      }, 10);
    }
  }

  function getConstrainedRange() {
    const selection = _window.getSelection();
    const range = selection.rangeCount && selection.getRangeAt(0);
    if (!range) return;

    const constrainedRange = constrainRange(range, options.selector);
    if (
      // prettier-ignore
      constrainedRange.collapsed || !constrainedRange.getClientRects().length
    ) {
      return;
    }

    // eslint-disable-next-line consistent-return
    return constrainedRange;
  }

  function styleSelectionFrame(range) {
    placeRect(range);
    if (popperInstance) {
      popperInstance.update();
    }
  }

  function iterateToTop(node, nodeIterator) {
    var nodeIterator = 0;
    var thePar = node;
    for (nodeIterator; nodeIterator < 100; nodeIterator++) {
      if (thePar.parentNode) {
        if (thePar.parentNode.nodeName !== "BODY") {
          //console.log(thePar.parentNode.nodeName);
          //console.log(thePar.parentNode.isConnected);

          nodeIterator++;
          thePar = thePar.parentNode;
        }
      }
    }
    return thePar;
  }
  function drawPopover(range) {
    const toBeOpened = !selectionFrame;
    const rawText = range.toString();

    const text = options.transformer(rawText);

    if (toBeOpened) {
      var thetop = iterateToTop(range.commonAncestorContainer);
      //console.log(thetop);

      rangeObj.text = text;
      rangeObj.startOffset = JSON.stringify(range.startOffset);
      rangeObj.endOffset = JSON.stringify(range.endOffset);
      rangeObj.startContainerData = JSON.stringify(range.startContainer.data);

      console.log(JSON.stringify(range.startOffset));
      console.log(JSON.stringify(range.endOffset));
      console.log(JSON.stringify(range.startContainer.data));

      selectionFrame = lifeCycle.createPopover();

      //popover.innerHTML = "<ul><li>en data</li></ul>";
      // render(options, sharers, text, rawText);
      //stylePopover(popover, range, options);

      //if (!toBeOpened) return;

      lifeCycle.attachPopover(selectionFrame);
    }

    styleSelectionFrame(range);
    if (!mainTooltip) {
      const tooltip = document.createElement("div");
      tooltip.setAttribute("id", "kontribut-tooltip");
      tooltip.setAttribute("role", "tooltip");
      const tooltipframe = document.createElement("iframe");
      tooltipframe.setAttribute("id", "kontribut-inner-frame");
      //tooltipframe.setAttribute("src", "about:blank");
      //tooltipframe.setAttribute("src", "/dist/innerframe.html");
      //"https://kontributtest.z6.web.core.windows.net/innerframe.html"
      tooltipframe.setAttribute(
        "src",
        "https://kontributtest.z6.web.core.windows.net/innerframe.html"
      );

      tooltipframe.setAttribute(
        "style",
        "width: 100%; height: 115px; border: none;"
      );
      tooltip.appendChild(tooltipframe);
      const tooltiparrow = document.createElement("div");
      tooltiparrow.setAttribute("id", "kontribut-arrow");
      tooltiparrow.setAttribute("data-popper-arrow", "");
      tooltip.appendChild(tooltiparrow);
      document.body.appendChild(tooltip);

      //mainTooltip = document.getElementById("kontribut-tooltip");
      /*
      var doc = tooltipframe.contentWindow.document;
      doc.open();
      doc.write(
        "<html><head><title></title></head><body style='background-color: white; font-family: -apple-system,Helvetica Neue,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Open Sans,sans-serif'><div>Do you have an opinion about this selection?</div><input type='text' id='kontrib-text-field' /><br /><input type='button' value='Contribute!' onclick='sendcontrib()' /><script>function sendcontrib() { window.parent.postMessage({sender: 'kontribut', text: 'hi there'}, '*');}</script></body></html>"
      );
      doc.close();
      */
      mainTooltip = tooltip;
    }

    if (toBeOpened) {
      const mediaQuery = window.matchMedia("(max-width: 576px)");
      let modarr = [];
      modarr.push({
        name: "offset",
        options: {
          offset: [0, 16],
        },
      });
      if (mediaQuery.matches) {
        modarr.push({
          name: "flip",
          options: {
            fallbackPlacements: [],
          },
        });
      }

      mainTooltip.setAttribute("data-show", "");
      popperInstance = createPopper(selectionFrame, mainTooltip, {
        placement: "bottom",
        modifiers: modarr,
      });
    }
    /*
      for mobile:
          {
            name: "flip",
            options: {
              fallbackPlacements: [],
            },
          },

    */

    //const selectionFrame = document.getElementById("kontribut-selection-frame");
    //const rangeRef = new RangeRef();

    //popperPop.update();

    /*
    console.log(range);

    if (toBeOpened) popover = lifeCycle.createPopover();

    popover.innerHTML = "<ul><li>en data</li></ul>";
    // render(options, sharers, text, rawText);
    stylePopover(popover, range, options);

    if (!toBeOpened) return;

    lifeCycle.attachPopover(popover);

    if (isCallable(options.onOpen)) {
      options.onOpen(popover, text, rawText);
    }
    */
  }

  function killPopover() {
    if (!selectionFrame) return;

    lifeCycle.removePopover(selectionFrame);
    selectionFrame = _undefined;
    if (popperInstance) {
      popperInstance.destroy();
      popperInstance = null;
    }

    if (mainTooltip) {
      mainTooltip.removeAttribute("data-show");
    }
  }

  var globsel;

  function placeRect(range, options) {
    const _document = document;
    const _window = _document.defaultView;
    const selection = _window.getSelection();
    globsel = JSON.stringify(selection);
    //console.log(JSON.stringify(selection));
    //const isForward = isSelectionForward(selection);
    const isForward = false;
    //const endLineRect = getEndLineRect(range, isForward);
    const endLineRect = getAllRect(range, isForward);

    //const refer = document.getElementById("kontribut-selection-frame");

    //refer.style.top = endLineRect.top;
    //refer.style.left = endLineRect.left;

    const offsetScroll = getOffsetScroll(_window);
    //const poppPlace = document.getElementById("poppan2");
    //console.log(endLineRect);

    const style = selectionFrame.style;
    /*
    if (isForward) {
      style.right = `${
        _document.documentElement.clientWidth -
        endLineRect.right +
        offsetScroll.left
      }px`;
    } else {
      style.left = `${endLineRect.left - offsetScroll.left}px`;
    }
    */
    style.left = `${endLineRect.left - offsetScroll.left}px`;

    style.width = `${endLineRect.right - endLineRect.left}px`;
    style.height = `${endLineRect.bottom - endLineRect.top}px`;
    style.top = `${endLineRect.top - offsetScroll.top}px`;
    style.position = "absolute";

    // eslint-disable-next-line no-param-reassign
    //popover.className = options.popoverClass;
  }

  function receiveMessage(event) {
    if (
      !event.data ||
      !event.data.sender ||
      !event.data.sender === "kontribut"
    ) {
      return;
    }

    const _document = document;
    const _window = _document.defaultView;
    const selection = _window.getSelection();
    const bod = JSON.stringify(rangeObj) + "\n" + JSON.stringify(event.data);
    fetch("https://pario-api.azurewebsites.net/api/Kontribut", {
      method: "POST",
      headers: new Headers(),
      body: bod,
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((err) => {
        console.log(err);
      });

    console.log("got the message!");
    console.log(event);
    setTimeout(function () {
      killPopover();
    }, 2000);

    // Do we trust the sender of this message?  (might be
    // different from what we originally opened, for example).
    if (event.origin !== "http://example.com") return;

    // event.source is popup
    // event.data is "hi there yourself!  the secret response is: rheeeeet!"
  }
};
